document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.elementor-menu-toggle').forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            document.body.classList.toggle('side-menu-opened');
            if (typeof attachSubArrowListeners === "function") {
                setTimeout(() => attachSubArrowListeners(), 500);
            }
        });
    });
    // Scroll to anchor
    document.querySelectorAll(".scroll-to a").forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            const href = this.getAttribute("href");
            if (href && href.startsWith("#")) {
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        });
    });

    // Disable links for specific elements
    document.querySelectorAll(".no-link > a").forEach(link => {
        link.setAttribute("href", "javascript:void(0);");
    });

   

    // Show or hide the sticky button on scroll
    window.addEventListener('scroll', function() {
        const backToTopButtons = document.querySelectorAll('.back-to-top');
        if (window.scrollY > 600) {
            backToTopButtons.forEach(button => button.classList.add('show'));
        } else {
            backToTopButtons.forEach(button => button.classList.remove('show'));
        }
    });

    // Animate the scroll to top on click
    document.querySelectorAll('.back-to-top').forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });

    // Custom aria label class "account-icon"
    document.querySelectorAll('.account-icon a').forEach(link => {
        // Only set if missing/empty to avoid overwriting an intentional label
        const current = link.getAttribute('aria-label');
        if (!current || !current.trim()) {
            link.setAttribute('aria-label', 'My Account');
        }
    });

    //ADA Remove tabindex from non-interactive elements
    // ADA: remove tabindex from non-interactive elements (guarded)
    const root = document.querySelector('.woocommerce.elementor-widget-loop-grid');
    if (root) {
        root.querySelectorAll('h2[tabindex],h3[tabindex],h4[tabindex],h5[tabindex],h6[tabindex],img[tabindex]')
            .forEach(el => el.removeAttribute('tabindex'));
    }

    // helper: jQuery-like slideToggle
    function slideToggle(el, duration = 500) {
        const isHidden = window.getComputedStyle(el).display === 'none' || el.hidden

        if (isHidden) {
            el.style.removeProperty('display')           // let CSS decide
            if (window.getComputedStyle(el).display === 'none') el.style.display = 'block'
            const height = el.scrollHeight + 'px'
            el.style.overflow = 'hidden'
            el.style.height = '0px'
            el.offsetHeight                               // reflow
            el.style.transition = `height ${duration}ms`
            el.style.height = height
            setTimeout(() => {
                el.style.removeProperty('height')
                el.style.removeProperty('overflow')
                el.style.removeProperty('transition')
            }, duration)
        } else {
            const height = el.scrollHeight + 'px'
            el.style.height = height
            el.style.overflow = 'hidden'
            el.offsetHeight                               // reflow
            el.style.transition = `height ${duration}ms`
            el.style.height = '0px'
            setTimeout(() => {
                el.style.display = 'none'
                el.style.removeProperty('height')
                el.style.removeProperty('overflow')
                el.style.removeProperty('transition')
            }, duration)
        }
    }

    const buttons = document.querySelectorAll('button.artBtn')
    const targets  = document.querySelectorAll('.artMore')

    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            // mimic jQuery('button.artBtn').toggleClass('less-rm') — toggles on ALL buttons
            buttons.forEach(b => b.classList.toggle('less-rm'))

            // mimic jQuery('.artMore').slideToggle(500) — toggle ALL targets
            targets.forEach(t => slideToggle(t, 500))
        })
    });

});
